// extracted by mini-css-extract-plugin
export var aboveScoreBoard = "BetTrackerLogo-module--aboveScoreBoard--9ed23";
export var betTracker = "BetTrackerLogo-module--betTracker--f2c75";
export var betTrackerText = "BetTrackerLogo-module--betTrackerText--c1e20";
export var boltIcon = "BetTrackerLogo-module--boltIcon--3d036";